module.exports = __webpack_public_path__ + "static/media/flechaCircle.96f874e4.svg";